// 点击复制


class ProductDiscount extends HTMLElement {
    constructor() {
        super(); 
    }
    connectedCallback(){
        this.variantId = this.dataset.id;
        this.price = this.dataset.price;
        this.symbol = this.dataset.symbol;
        this.showMoreDiscounts = this.dataset.showMoreDiscounts !== 'false';
       
        this.graphqlToken = "64c3e671e1dbac66441413c989b366c4"; // token
        this.VERSION = '2023-10'; // 版本
        this.list = window.staticData.codeList;

        const available = JSON.parse(this.dataset.available) || false;
        
        if(available){ 
            this.init();
        }else{
            var data = JSON.parse(this.dataset.default);
            
            this.updatePrice(Number(data.price),Number(data.compare));
        }
       
    }
    // 初始化
    async init(){
        const { data:{cartCreate:{cart}}} = await this.request(this.queryInfo('cartCreate'), {});
        const cartId = cart.id;
        this.cartId = cartId;
        
        const checkoutInfo = {
            "merchandiseId": `gid://shopify/ProductVariant/${Number(this.variantId)}`,
            "quantity": 1
        }

        // 加入购物车
        const {data:{cartLinesAdd}} = await this.request(this.queryInfo('cartAdd'), { cartId: this.cartId, lines: [checkoutInfo] });

 
        if (!cartLinesAdd.cart) {
            console.error('Error adding to cart:', cartLinesAdd.userErrors);
           
             var data = JSON.parse(this.dataset.default);
            this.updatePrice(Number(data.price),Number(data.compare));
        }else{
            document.querySelector(".product__price__wrap").classList.add("loading");
            this.discountCharge(this.price); 
        }
              
        
    }
    formatMoney(t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let s = "";
        const i = /\{\{\s*(\w+)\s*\}\}/
          , o = e || "${{amount}}";
        function r(t, e=2, s=",", i=".") {
            if (isNaN(t) || null == t)
                return 0;
            const o = (t = (t / 100).toFixed(e)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) + (o[1] ? i + o[1] : "")
        }
        switch (o.match(i)[1]) {
        case "amount":
            s = r(t, 2);
            break;
        case "amount_no_decimals":
            s = r(t, 0);
            break;
        case "amount_with_comma_separator":
            s = r(t, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            s = r(t, 0, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            s = r(t, 2, "'", ".");
            break;
        case "amount_no_decimals_with_space_separator":
            s = r(t, 0, " ", "");
            break;
        case "amount_with_space_separator":
            s = r(t, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            s = r(t, 2, " ", ".")
        }
        return o.replace(i, s)
    }

    // 只要处理展示的价格信息
    updatePrice(price,compare_at_price){
        // 设置优化价格区域
        if(this.querySelector(".after-code")){
            this.querySelector(".after-code").innerHTML = this.formatMoney(price, window.theme.moneyWithoutCurrencyFormat);
            this.querySelector(".before-code").innerHTML = this.formatMoney(compare_at_price, window.theme.moneyWithoutCurrencyFormat);
            this.querySelector(".code-discount").innerHTML = this.formatMoney((compare_at_price - price), window.theme.moneyWithoutCurrencyFormat);
            this.querySelector(".is-best").style.display="none";
            this.querySelector(".active-warp").innerHTML = "";
            this.querySelector(".discount-list").innerHTML = "";
            this.querySelector(".is-other").style.display="none";
        }
     }

    // 判断折扣信息
    async discountCharge(price){
       const discountCodes = this.list.map(item => item.code);
        const {data:{cartDiscountCodesUpdate:{cart,userErrors}}} = await this.request(this.queryInfo('updateCartDiscounts'), { cartId: this.cartId, discountCodes });

        // 不管其他，只处理加购之后的价格
        if (this.showMoreDiscounts && document.querySelector(".product__content .product__price__wrap span[data-product-price]")) {
            document.querySelector(".product__content .product__price__wrap span[data-product-price]").textContent=this.symbol + Number(cart.cost.totalAmount.amount).toFixed(2); 
        }
            



        const amount = Number(cart.cost.totalAmount.amount) * 100;
        const code = (((Number(price) - amount)/Number(price)) * 100).toFixed(0);
        if(document.querySelector(".product__content .product__price__wrap .product__price--off span")){
            document.querySelector(".product__content .product__price__wrap .product__price--off span").textContent=code +"%";
        }

        // 处理悬浮窗价格显示
        if(document.querySelector(".cart-bar span[data-product-price]")){
            document.querySelector(".cart-bar span[data-product-price]").textContent=this.symbol + Number(cart.cost.totalAmount.amount).toFixed(2);
        }



        // 设置优化价格区域
        this.querySelector(".after-code").innerHTML = this.formatMoney((cart.cost.totalAmount.amount) * 100 , theme.moneyWithoutCurrencyFormat);
        this.querySelector(".before-code").innerHTML = this.formatMoney(price , theme.moneyWithoutCurrencyFormat);
    
        this.querySelector(".code-discount").innerHTML = this.formatMoney(price - (cart.cost.totalAmount.amount) * 100 , theme.moneyWithoutCurrencyFormat);

        // 判断存在能应用上的折扣
        const discount_code = cart.discountCodes.find(discount => discount.applicable === true);

        if(discount_code){

            const temp = this.list.find(item => item.code === discount_code.code);

            const warp = document.createElement("div");
            warp.innerHTML = `<div class="discount-product-item is-active"><div class="discount-selected">Recommended</div>
              <div class="discount-copy" onclick="copyToClipboard('${temp.code}','toast')" data-code="${temp.code}"></div>
              <div class="discount-left"><span class="red">${this.symbol}${temp.save}</span><p class="red">off</p></div>
              <div class="discount-right"><span>code: ${temp.code}</span><p>${temp.term}</p></div></div>`;
              
            this.querySelector(".active-warp").innerHTML = warp.innerHTML;
            this.querySelector(".is-best").style.display="block";

            if(cart.discountCodes.length == 1){
                this.querySelector(".is-other").style.display="none";
            }
            var otherWarp = '';
            cart.discountCodes.forEach((discount) => {
                if(discount.applicable == false){
                    var temp = this.list.find(item => item.code === discount.code);
                    otherWarp +=`<div class="discount-product-item">
                    <div class="discount-copy" onclick="copyToClipboard('${temp.code}','toast')" data-code="${temp.code}"></div>
                    <div class="discount-left"><span class="red">${this.symbol}${temp.save}</span><p class="red">off</p>
                    </div>
                    <div class="discount-right"><span>code: ${temp.code}</span><p>${temp.term}</p>
                    </div>
                </div>`
                }
            });

            this.querySelector(".discount-list").innerHTML = otherWarp;
            this.querySelector(".is-other").style.display="block";

        }else{
     
            this.querySelector(".is-best").style.display="none";
            this.querySelector(".active-warp").innerHTML = "";
            this.querySelector(".discount-list").innerHTML = "";
            this.querySelector(".is-other").style.display="none";
        }

        document.querySelector(".product__price__wrap").classList.remove("loading");
        

    }
    // 切换变体的时候更新购物车
    async changeVariant(id,line,price){
        document.querySelector(".product__price__wrap").classList.add("loading");
        // 需要添加的变体ID
        const checkoutInfo = {
            "merchandiseId": `gid://shopify/ProductVariant/${Number(id)}`,
            "quantity": 1
            }

        // 创建一个新的catid
        const { data:{cartCreate:{cart}}} = await this.request(this.queryInfo('cartCreate'), {});
        const cartId = cart.id;
        this.cartId = cartId;
        const {data:{cartLinesAdd}} = await this.request(this.queryInfo('cartAdd'), { cartId, lines: [checkoutInfo] });

        if (!cartLinesAdd.cart) {
             document.querySelector(".product__price__wrap").classList.remove("loading");
            this.updatePrice(Number(line),Number(price));
        }else{
            this.discountCharge(price);
        }
       
    
    }


    // 设置请求query
    queryInfo(type = '') {
        switch (type) {
        // 获取购物车ID
        case 'cartCreate':
            return `mutation cartCreate {
            cartCreate(input: {}) {
            cart {
                id
            }
            userErrors {
                code
                }
            }
        }`
        // 加入购物车
        case 'cartAdd':
            return `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
            cartLinesAdd(cartId: $cartId, lines: $lines) {
                cart {
                        id
                        discountCodes {
                            code
                            applicable
                        }
                        discountAllocations {
                            discountedAmount {
                            amount
                            currencyCode
                            }
                        }
                        lines(first: 10) {
                            edges {
                            node {
                                id
                                discountAllocations {
                                discountedAmount {
                                    amount
                                    currencyCode
                                }
                                }
                            }
                            }
                        }
                }
                userErrors {
                    field
                    message
                }
            }
        }`
        // 获取购物车列表
        case 'getCart':
            return `query getCart($cartId: ID!) {
            cart(id: $cartId) {
                id
                lines(first: 50) {
                edges {
                    node {
                    id
                    quantity
                    merchandise {
                        ... on ProductVariant {
                            id
                            title
                            availableForSale
                            price {
                                amount
                                currencyCode
                            }
                            compareAtPrice {
                                amount
                                currencyCode
                            }
                        }
                    }
                    cost {
                            subtotalAmount {
                                amount
                                currencyCode
                            }
                        }
                    }
                    }
                }
            }
        }`
        // 删除购物车选项
        case 'removeMutation':
            return `mutation clearCart($cartId: ID!, $lineIds: [ID!]!) {
                cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
                    cart {
                        id
                        totalQuantity
                    }
                    userErrors {
                        field
                        message
                    }
                }
            }`
         // 判断折扣是否能应用
        case 'updateCartDiscounts':
            return `mutation updateCartDiscounts($cartId: ID!, $discountCodes: [String!]!) {
                cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
                    cart {
                    id
                    discountCodes {
                        code
                        applicable
                    }
                    cost {
                        subtotalAmount {
                            amount
                            currencyCode
                        }
                        totalAmount {
                            amount
                            currencyCode
                        }
                    }
                    }
                    userErrors {
                        field
                        message
                    }
                }
             }` 
        default:
            break
        }
    }

    // 请求
    async request(query, parameter) {
        const shopInfo = window.Shopify || {}
        const res = await fetch(
            `https://${shopInfo.shop}/api/${this.VERSION}/graphql.json`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': this.graphqlToken
                },
                body: JSON.stringify({ query, variables: parameter })
            }
        )
        const data = await res.json()
        return data
    }

}

if (!customElements.get('product-discount')) {
    customElements.define('product-discount', ProductDiscount);
}